import { Col, Row } from "react-bootstrap";
import { EEnergyNeedEditParameter } from "../../../../shared/oversight-core/enums/energy-need-edit-parameters";
import { EInverterPhaseType } from "../../../../shared/oversight-core/enums/inverter-phase-type";
import { ESolarSystemType } from "../../../../shared/oversight-core/enums/solar-system-type ";
import AppDropDown from "../../../../shared/oversight-core/ui-elements/app-dropdown/app-drop-down";
import { Option } from "../../../../shared/oversight-core/ui-elements/app-select/app-select";
import MaterialIcon from "../../../../shared/oversight-core/ui-elements/material-icon/material-icon";
import Helper from "../../../../shared/oversight-core/utils/helpers";

interface IProps {
  onParameterEdit?: (type: EEnergyNeedEditParameter) => void;
  monthlyEnergyNeed: number;
  monthlyEnergyNeedFromUser: number;
  maxPower: number;
  maxPowerFromUser: number;
  nightLoad: number;
  sunlightHours: number;
  dischargeRate: number;
  totalWattHours: number;
  maxPowerInWatt: number;
  isHideEditIcon?: boolean;
  solarSystemType: Option;
  inverterPhaseType: Option;
  onChangeSolarSystemType: (option: Option) => void;
  onChangeInverterPhaseType: (option: Option) => void;
  onDeleteSolarSystem?: () => void;
  isHideDeleteIcon?: boolean;
}

const SelectedSolarSystemCard = (props: IProps) => {
  const {
    monthlyEnergyNeed,
    monthlyEnergyNeedFromUser,
    maxPower,
    maxPowerFromUser,
    dischargeRate,
    nightLoad,
    sunlightHours,
    totalWattHours,
    maxPowerInWatt,
    onParameterEdit,
    isHideEditIcon = false,
    isHideDeleteIcon = false,
    solarSystemType,
    onChangeSolarSystemType,
    inverterPhaseType,
    onChangeInverterPhaseType,
    onDeleteSolarSystem,
  } = props;

  return (
    <div className="theme-card-3 p-3 rounded-3">
      <Row className="row-cols-auto justify-content-between align-items-center">
        <Col>
          <Row className="row-cols-auto flex-column flex-md-row align-items-md-end justify-content-md-between gx-3">
            <Col>
              <Row className="flex-row flex-md-column gy-2">
                <Col>
                  <MaterialIcon
                    icon="solar_power"
                    color="var(--color-system-icon)"
                    fill
                  />
                </Col>
                <Col className="text-color-4 font-weight-500 font-size-14">
                  Required
                </Col>
                <Col className="text-color-4 font-weight-500 font-size-14">
                  Selected
                </Col>
              </Row>
            </Col>
            <Col>
              <Row className="flex-row flex-md-column gy-2">
                <Col className="text-color-4 font-weight-400 font-size-12">
                  Monthly Energy Need
                </Col>
                <Col>
                  <Row className="row-cols-auto align-items-center">
                    <Col className="text-setting-item-selected font-weight-600 font-size-13 pe-0">
                      {monthlyEnergyNeedFromUser > 0
                        ? `${monthlyEnergyNeed.toFixed(
                            2
                          )} + ${monthlyEnergyNeedFromUser.toFixed(2)} Units`
                        : monthlyEnergyNeed > 0
                        ? `${monthlyEnergyNeed.toFixed(2)} Units`
                        : "-"}
                    </Col>
                    {!isHideEditIcon && (
                      <Col className="ps-2">
                        <MaterialIcon
                          icon="border_color"
                          className="cursor-pointer"
                          color="var(--color-edit-icon-2)"
                          size={14}
                          onClick={() => {
                            onParameterEdit &&
                              onParameterEdit(
                                EEnergyNeedEditParameter.MONTHLY_ENERGY_NEED
                              );
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col
                  className={`font-weight-700 ${
                    totalWattHours === 0
                      ? "text-setting-item-selected"
                      : totalWattHours / 1000 >=
                        monthlyEnergyNeed + monthlyEnergyNeedFromUser
                      ? "status-approved"
                      : "text-danger"
                  }`}
                >
                  {totalWattHours > 0
                    ? `${(totalWattHours / 1000).toFixed(2)} Units`
                    : "-"}
                </Col>
              </Row>
            </Col>
            <Col>
              <Row className="flex-row flex-md-column gy-2">
                <Col className="text-color-4 font-weight-400 font-size-12">
                  Max Power
                </Col>
                <Col>
                  <Row className="row-cols-auto align-items-center">
                    <Col className="text-setting-item-selected font-weight-600 font-size-13 pe-0">
                      {maxPowerFromUser > 0
                        ? `${Helper.roundTo2(
                            maxPower / 1000
                          )} + ${maxPowerFromUser.toFixed(2)} kW`
                        : maxPower > 0
                        ? `${Helper.roundTo2(maxPower / 1000)} kW`
                        : "-"}
                    </Col>
                    {!isHideEditIcon && (
                      <Col className="ps-2">
                        <MaterialIcon
                          icon="border_color"
                          className="cursor-pointer"
                          color="var(--color-edit-icon-2)"
                          size={14}
                          onClick={() => {
                            onParameterEdit &&
                              onParameterEdit(
                                EEnergyNeedEditParameter.MAX_POWER
                              );
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col
                  className={`font-weight-700 ${
                    maxPowerInWatt === 0
                      ? "text-setting-item-selected"
                      : maxPowerInWatt / 1000 >=
                        maxPower / 1000 + maxPowerFromUser
                      ? "status-approved"
                      : "text-danger"
                  }`}
                >
                  {maxPowerInWatt > 0
                    ? `${(maxPowerInWatt / 1000).toFixed(2)} kW`
                    : "-"}
                </Col>
              </Row>
            </Col>
            {dischargeRate > 0 && (
              <Col>
                <Row className="flex-row flex-md-column gy-2">
                  <Col className="text-color-4 font-weight-400 font-size-12">
                    Discharge Rate
                  </Col>
                  <Col>
                    <Row className="row-cols-auto align-items-center">
                      <Col className="text-setting-item-selected font-weight-600 font-size-13 pe-0">
                        {dischargeRate.toFixed(2)}%
                      </Col>
                    </Row>
                  </Col>
                  <Col className="font-weight-700">&nbsp;</Col>
                </Row>
              </Col>
            )}
            <Col>
              <Row className="flex-row flex-md-column gy-2">
                <Col className="text-color-4 font-weight-400 font-size-12">
                  Night Load
                </Col>
                <Col>
                  <Row className="row-cols-auto align-items-center">
                    <Col className="text-setting-item-selected font-weight-600 font-size-13 pe-0">
                      {nightLoad.toFixed(2)}%
                    </Col>
                    {!isHideEditIcon && (
                      <Col className="ps-2">
                        <MaterialIcon
                          icon="border_color"
                          className="cursor-pointer"
                          color="var(--color-edit-icon-2)"
                          size={14}
                          onClick={() => {
                            onParameterEdit?.(
                              EEnergyNeedEditParameter.NIGHT_LOAD
                            );
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col className="font-weight-700">&nbsp;</Col>
              </Row>
            </Col>
            <Col>
              <Row className="flex-row flex-md-column gy-2">
                <Col className="text-color-4 font-weight-400 font-size-12">
                  Sunlight
                </Col>
                <Col>
                  <Row className="row-cols-auto align-items-center">
                    <Col className="text-setting-item-selected font-weight-600 font-size-13 pe-0">
                      {sunlightHours}h
                    </Col>
                    {!isHideEditIcon && (
                      <Col className="ps-2">
                        <MaterialIcon
                          icon="border_color"
                          className="cursor-pointer"
                          color="var(--color-edit-icon-2)"
                          size={14}
                          onClick={() => {
                            onParameterEdit?.(
                              EEnergyNeedEditParameter.SUNLIGHT_HOURS
                            );
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col className="font-weight-700">&nbsp;</Col>
              </Row>
            </Col>
            <Col>
              <Row
                className={`flex-row flex-md-column ${
                  isHideEditIcon ? "gy-2" : "gy-1"
                }`}
              >
                <Col className="text-color-4 font-weight-400 font-size-12">
                  Solution Type
                </Col>
                <Col>
                  <Row className="row-cols-auto align-items-center">
                    <Col className="text-setting-item-selected font-weight-600 font-size-13 pe-0">
                      {solarSystemType.label}
                    </Col>
                    {!isHideEditIcon && (
                      <Col className="ps-2">
                        <AppDropDown
                          items={[
                            {
                              onClick: () => {
                                onChangeSolarSystemType({
                                  value: ESolarSystemType.HYBRID,
                                  label: "Hybrid",
                                });
                              },
                              text: "Hybrid",
                            },
                            {
                              onClick: () => {
                                onChangeSolarSystemType({
                                  value: ESolarSystemType.OFF_GRID,
                                  label: "Off-Grid",
                                });
                              },
                              text: "Off-Grid",
                            },
                            {
                              onClick: () => {
                                onChangeSolarSystemType({
                                  value: ESolarSystemType.BACKUP,
                                  label: "Backup",
                                });
                              },
                              text: "Backup",
                            },
                          ]}
                          icon="arrow_drop_down"
                          showBackgroundAndBorder={false}
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col className="font-weight-700">&nbsp;</Col>
              </Row>
            </Col>
            {solarSystemType.value !== ESolarSystemType.OFF_GRID && (
              <Col>
                <Row
                  className={`flex-row flex-md-column ${
                    isHideEditIcon ? "gy-2" : "gy-1"
                  }`}
                >
                  <Col className="text-color-4 font-weight-400 font-size-12">
                    Grid Type
                  </Col>
                  <Col>
                    <Row className="row-cols-auto align-items-center">
                      <Col className="text-setting-item-selected font-weight-600 font-size-13 pe-0">
                        {inverterPhaseType.label}
                      </Col>
                      {!isHideEditIcon && (
                        <Col className="ps-2">
                          <AppDropDown
                            items={[
                              {
                                onClick: () => {
                                  onChangeInverterPhaseType({
                                    value: EInverterPhaseType.SINGLE_PHASE,
                                    label: "1 Phase",
                                  });
                                },
                                text: "1 Phase",
                              },
                              {
                                onClick: () => {
                                  onChangeInverterPhaseType({
                                    value: EInverterPhaseType.THREE_PHASE,
                                    label: "3 Phase",
                                  });
                                },
                                text: "3 Phase",
                              },
                              {
                                onClick: () => {
                                  onChangeInverterPhaseType({
                                    value: EInverterPhaseType.NONE,
                                    label: "None",
                                  });
                                },
                                text: "None",
                              },
                            ]}
                            icon="arrow_drop_down"
                            showBackgroundAndBorder={false}
                          />
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col className="font-weight-700">&nbsp;</Col>
                </Row>
              </Col>
            )}
          </Row>
        </Col>
        {!isHideDeleteIcon && (
          <Col>
            <MaterialIcon
              icon="delete"
              color="#E63E35"
              size={18}
              className="cursor-pointer"
              onClick={onDeleteSolarSystem}
            />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default SelectedSolarSystemCard;
